import React from 'react'
import styled from 'styled-components'

const CheckboxContainer = styled.span`
  display: flex;
  vertical-align: middle;
  position: relative;
`

const CheckMark = styled.span`
  fill: none;
  stroke: #5789FA;
  stroke-width: 2px;
`

const IndeterminateMark = styled.span`
  fill: none;
  stroke: #5789FA;
  stroke-width: 2px;
`

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  width: 18px !important;
  height: 18px !important;
  position: absolute;
  left: 0;
  z-index: 999 !important;
  cursor: pointer;
  opacity: 0;
  top: 0;
  bottom: 0;
  right: 0;
`

const StyledCheckbox = styled.div`
  display: flex;
  width: 18px;
  height: 18px;
  background: ${props => ((props.checked || props.indeterminate) ? '#FFF' : 'transparent')}
  border-radius: 2px;
  border: ${props => ((props.checked || props.indeterminate) ? '1px solid #5789FA' : '1px solid #b0bcd0')};

  ${HiddenCheckbox}:focus, ${HiddenCheckbox}:hover + & {
    border-color: #5789FA;
  }

  ${HiddenCheckbox}[disabled]:focus, ${HiddenCheckbox}[disabled]:hover + &  {
    border-color: #b0bcd0; 
  }

  ${IndeterminateMark} {
    visibility: ${props => (props.indeterminate ? 'visible' : 'hidden')}
    position: absolute;
    border: 2px solid #ffffff;
    content: ' ';
    background: #5789FA;
    width: 16px;
    height: 16px;
  }


  ${CheckMark} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
    transform: rotate(45deg);
    position: absolute;
    border: 2px solid #ffffff;
    border-top: 0;
    border-left: 0;
    content: ' ';
    border-color: #5789FA;
    left: 6px;
    top: 3px;
    width: 5px;
    height: 10px;
  }
`

const Checkbox = ({ className, checked, indeterminate, ...props }) => (
    <CheckboxContainer className={className}>
        <HiddenCheckbox checked={checked} indeterminate={indeterminate} {...props} />
        <StyledCheckbox checked={checked} indeterminate={indeterminate}>
            {checked &&
                <CheckMark />
            }
            {indeterminate &&
                <IndeterminateMark />
            }
        </StyledCheckbox>
    </CheckboxContainer>
)


export default Checkbox
